__webpack_require__.p = "https://ikea.marat.qd.je/jp/en/customer-service/support/";